import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
  AfterViewChecked
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import {
  AlertController,
  ModalController,
  LoadingController,
  ToastController
} from '@ionic/angular';
import { Observable, debounceTime, from} from 'rxjs';
import {mergeMap} from 'rxjs/operators';

import { Stylist } from '../../models/stylist/stylist.model';
import { Client } from '../../models/client/client.model';
import { ServiceCategory } from '../../models/service-category/service-category.model';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { UserService } from '../../services/user.service';
import {
  BulkTextRecipient,
  BulkTextService
} from '../../services/bulk-text.service';
import { ServiceCategoryService } from '../../services/service-category.service';
import { Utilities } from '../../utilities/utilities';

import { List } from 'immutable';

import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';


@Component({
  selector: 'smr-text-marketing-composer',
  templateUrl: './marketing-composer.component.html',
  styleUrls: ['./marketing-composer.component.scss'],
})
export class TextMarketingComposerComponent 

  implements OnInit {
    @ViewChild(StylistPickerComponent)
    stylistPickerComponent: StylistPickerComponent;
  
    public isLoading: boolean = true;
  
    public errorOccurredWhileLoadingStylistPicker: boolean;
  
    public stylistID: number;
    
    public showAllStaff: boolean = true;

  
    public readOnlyStylistPicker: boolean;
  
    public submitAttempt: boolean;
  
    public currency: string;
  
    public marketingComposerForm: UntypedFormGroup;
  
    public bulkText: UntypedFormControl;
  
    public filterType: UntypedFormControl;
  
    public appointmentBeforeAfterOption: UntypedFormControl;
  
    public appointmentStartDateOption: UntypedFormControl;
  
    public appointmentEndDateOption: UntypedFormControl;
  
    public spentRangeOption: UntypedFormControl;
  
    public spentStartPrice: UntypedFormControl;
  
    public spentEndPrice: UntypedFormControl;
  
    public birthdayRangeOption: UntypedFormControl;
  
    public birthdayStartDate: UntypedFormControl;
  
    public birthdayEndDate: UntypedFormControl;
  
    public serviceSelector: UntypedFormControl;
  
    public serviceCategories: List<ServiceCategory>;
  
    public numberOfRecipients: number;
  
    public loadingRecipients: boolean;
  
    public dateError:any={isError:false,errorMessage:''};

    public recipients;

    public selectedRecipients;

    public segmentCount: number = 0;
  
    constructor(
      private userService: UserService,
      private bulkTextService: BulkTextService,
      private serviceCategoryService: ServiceCategoryService,
      private formBuilder: UntypedFormBuilder,
      private cdRef: ChangeDetectorRef,
      private toastService: ToastService,
      private alertService: AlertService,
      private loadingCtrl: LoadingController
    ) {
      this.isLoading = true;
      this.currency = Utilities.decodeHTML(
        this.userService.getSalon()
          ? this.userService.getSalon().getCurrency()
          : ''
      );
      this.serviceCategories = List([]);
      this.numberOfRecipients = 0;
      this.loadingRecipients = false;
  
      if (this.userService.isLoggedIn()) {
        const user = this.userService.getUser();
        this.stylistID = user.getID();
        if (user.isAdministrator()) {
          this.readOnlyStylistPicker = false;
        } else {
          this.readOnlyStylistPicker = true;
        }
      }
  
      this.filterType = new UntypedFormControl('allclients');
      this.bulkText = new UntypedFormControl('',  Validators.required);
  
      // extra filter options
      this.appointmentBeforeAfterOption = new UntypedFormControl('before');
      this.appointmentStartDateOption = new UntypedFormControl(
        Utilities.formatDate(new Date(), 'Y-MM-DD')
      );
      this.appointmentEndDateOption = new UntypedFormControl(
        Utilities.formatDate(Utilities.addDays(new Date(), 7), 'Y-MM-DD')
      );
  
      this.spentRangeOption = new UntypedFormControl('morethan');
      this.spentStartPrice = new UntypedFormControl(0);
      this.spentEndPrice = new UntypedFormControl(0);
  
      this.birthdayRangeOption = new UntypedFormControl('ison');
      this.birthdayStartDate = new UntypedFormControl(
        Utilities.formatDate(new Date(), 'Y-MM-DD')
      );
      this.birthdayEndDate = new UntypedFormControl(
        Utilities.formatDate(Utilities.addDays(new Date(), 7), 'Y-MM-DD')
      );
  
      this.serviceSelector = new UntypedFormControl();
  
      this.marketingComposerForm = this.formBuilder.group({
        filterType: this.filterType,
        bulkText: this.bulkText,

        // extra options
        appointmentBeforeAfterOption: this.appointmentBeforeAfterOption,
        appointmentStartDateOption: this.appointmentStartDateOption,
        appointmentEndDateOption: this.appointmentEndDateOption,
  
        spentRangeOption: this.spentRangeOption,
        spentStartPrice: this.spentStartPrice,
        spentEndPrice: this.spentEndPrice,
  
        birthdayRangeOption: this.birthdayRangeOption,
        birthdayStartDate: this.birthdayStartDate,
        birthdayEndDate: this.birthdayEndDate,
  
        serviceSelector: this.serviceSelector
      });

      this.marketingComposerForm.get("bulkText").valueChanges.subscribe(value => {
        bulkTextService.getSegmentCount(value).subscribe(count => {
          this.segmentCount = count;
        })
      });

      this.selectedRecipients = new UntypedFormControl();
    }

    public ngAfterViewChecked() {
      this.cdRef.detectChanges();
    }
  
    public ngOnInit() {
      this.refreshNumberOfRecipients();
    }
  

  
    public onStylistPickerInit(initResponse: {
      success: boolean;
      stylist: Stylist;
    }) {
      if (initResponse.success) {
        this.onStylistSelect(initResponse.stylist);
      } else {
        this.isLoading = false;
        this.errorOccurredWhileLoadingStylistPicker = true;
      }
    }
  
    public onTapToReload() {
      this.isLoading = true;
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();
    }
  
    public onStylistSelect(stylist: Stylist) {
      this.isLoading = false;
      this.stylistID = stylist.id;
      this.refreshNumberOfRecipients();
    }
  
  
    public resetForm() {
      this.submitAttempt = false;
      this.filterType.setValue('allclients');
      this.bulkText.setValue('');
    }
  
  
    public recipientsRequestBuilder(): Observable<List<BulkTextRecipient>> {
        switch (this.filterType.value) {
          case 'allclients':
            return this.bulkTextService.stylistClientsRecipients(
              this.bulkText.value,
              this.stylistID
            );
          case 'appointment':
            return this.bulkTextService.clientsWhoseAppointmentsRecipients(
              this.bulkText.value,
              this.stylistID,
              this.appointmentBeforeAfterOption.value,
              this.appointmentStartDateOption.value,
              this.appointmentEndDateOption.value
            );
          case 'spent':
            return this.bulkTextService.clientsWhoSpentRecipients(
              this.bulkText.value,
              this.stylistID,
              this.spentRangeOption.value,
              parseFloat(this.spentStartPrice.value),
              parseFloat(this.spentEndPrice.value)
            );
          case 'birthday':
            return this.bulkTextService.clientsWhoseBirthdayRecipients(
              this.bulkText.value,
              this.stylistID,
              this.birthdayRangeOption.value,
              this.birthdayStartDate.value,
              this.birthdayEndDate.value
            );
          case 'service':
            return this.bulkTextService.clientsWhoHadServiceRecipients(
              this.bulkText.value,
              this.stylistID,
              this.serviceSelector.value
            );
          default:
            break;
        }
    }
  
    public filterChanged() {
      if (this.filterType.value === 'service') {
        this.serviceCategories = List([]);
        this.serviceCategoryService
          .getServiceCategories(this.stylistID, this.userService.getSalon().getId(),true)
          .subscribe({
            next:(result) => {
              this.serviceCategories = result;
  
              const serviceCategory = this.serviceCategories.first();
              const serviceDefinition = serviceCategory.serviceDefinitions.first();
              this.serviceSelector.setValue(
                serviceDefinition ? serviceDefinition.name : undefined
              );
            },
            error: (e) => {}
          });
      }
  
      this.refreshNumberOfRecipients();
    }
  
    public refreshNumberOfRecipients() {
      this.numberOfRecipients = 0;
      this.loadingRecipients = true;
      this.recipientsRequestBuilder().subscribe({
        next:(recipients: List<BulkTextRecipient>) => {
          this.recipients = recipients.toArray();
          this.selectedRecipients = recipients.toArray();
          this.numberOfRecipients = recipients.count();
          this.loadingRecipients = false;
        },
        error: (e) => {
          this.loadingRecipients = false;
        }
      });
    }
  
    public compareTwoDates(){
      this.refreshNumberOfRecipients();
      if(new Date(this.birthdayEndDate.value)<new Date(this.birthdayStartDate.value)){
         this.dateError={isError:true,errorMessage:"End date can't before start date"};
      } else {
        this.dateError={isError:false,errorMessage:""};
      }
    }


    public async send(){
      this.submitAttempt = true;
  
      if (!this.marketingComposerForm.valid) {
        return;
      }
  
      // display an ion-alert to notify the user of the cost of sending the text.

      // "Your payment card will be charged $1.00 to send this bulk text message."
      // "1 text segment(s) x 1 client x $0.05/message = $0.05"
      // [Cancel, Send]
      const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
        return this.bulkTextService.sendToSelectedClients(
          this.stylistID,
          this.bulkText.value,
          this.selectedRecipients)
        .subscribe({
        next:(response) => {
          loader.dismiss().then(() => {
            this.resetForm();
            this.toastService.presentSimpleToast(`Message has been sent`, 3000);
          });
        },
        error: (e) => {
          loader.dismiss().then(() => {
            this.alertService.presentErrorAlert();
          });
        }
      });
    }

}
